var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeakerQueue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.56,14.39a3.74,3.74,0,1,0-3.74-3.73A3.73,3.73,0,0,0,15.56,14.39Zm-1.67-3.73a1.67,1.67,0,1,1,1.67,1.67A1.67,1.67,0,0,1,13.89,10.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.56,15a6.45,6.45,0,0,0-6.44,6.44V22h2.06v-.52a4.38,4.38,0,1,1,8.75,0V22H22v-.52A6.45,6.45,0,0,0,15.56,15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44,12.19a4.33,4.33,0,0,1,1.53.29,6.41,6.41,0,0,1,1.09-.25,4.14,4.14,0,0,1-2.72-2.1A6.45,6.45,0,0,0,2,16.56v.53H4.06v-.53A4.38,4.38,0,0,1,8.44,12.19Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05,9.44a3.93,3.93,0,0,1-.2-1.24,4.14,4.14,0,0,1,.09-.87A1.66,1.66,0,0,1,6.77,5.75a1.66,1.66,0,0,1,3-1,4.06,4.06,0,0,1,2-.65A3.73,3.73,0,1,0,8.05,9.44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12,14.65a4.33,4.33,0,0,1,1.53.29,7.53,7.53,0,0,1,1.09-.25,4.11,4.11,0,0,1-2.72-2.1A6.45,6.45,0,0,0,5.56,19v.52H7.62V19A4.39,4.39,0,0,1,12,14.65Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61,11.9a3.93,3.93,0,0,1-.2-1.24,4.14,4.14,0,0,1,.09-.87,1.66,1.66,0,1,1,1.81-2.61,4.06,4.06,0,0,1,2-.65,3.73,3.73,0,1,0-3.71,5.37Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerQueue);
export default __webpack_public_path__ + "static/media/speaker-queue.7d925815b60308da6ef839caa47a1665.svg";
export { ForwardRef as ReactComponent };